<div dsTouchClick class="breadcrumb-back" (click)="goBack()">
    <span class="breadcrumb-theme-left">
        <vn-icon name="theme-left" [size]="isEpcotEnabled() ? '16' : '14'" />
    </span>
</div>
@if (items.length) {
    <div class="breadcrumb-items" msScrollIosHack msScrollTo>
        @for (crumb of items; track crumb) {
            <div #msScrollToItem class="breadcrumb-item" [class]="crumb.classes">
                @if (crumb.url) {
                    <a [href]="crumb.url" (click)="selected(crumb)">
                        <ng-container *ngTemplateOutlet="linkTemplate; context: { $implicit: crumb }" />
                    </a>
                } @else {
                    <a>
                        <ng-container *ngTemplateOutlet="linkTemplate; context: { $implicit: crumb }" />
                    </a>
                }
            </div>
        }
    </div>
}

<ng-container #breadcrumbSlot />

<ng-template #linkTemplate let-crumb>
    @if (!minimalBreadcrumbs && crumb.sportId && crumb.leagueId) {
        <ms-competition-logo
            [sportId]="crumb.sportId"
            [leagueId]="crumb.leagueId"
            [fallbackIcon]="crumb.fallbackIcon"
            [isWithRightImage]="crumb.isWithRightImage"
            [imageProfile]="crumb.imageProfile" />
    } @else if (crumb.icon) {
        <vn-icon size="16" [name]="crumb.icon" />
    }
    <span class="breadcrumb-title">{{ crumb.title }}</span>
</ng-template>
